<template>
<div class="row p-t-lg immolisting">
  <div class="col-24 col-md-24 col-lg-8" v-for="item in items" :key="item.objectId">
    <div class="immolisting__wrapper">
        <expose :item="item" />

        <div v-if="item.features && item.features.indexOf('calendar') > -1">
          <router-link :to="{ name: 'expose-calendar', params: { exposeId: item.exposeId } }">
            <button class="btn btn-primary calender-button">Besichtigungstermin</button>
          </router-link>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Expose from "./Expose";

export default {
  name: 'ExposeList',

  components: {
    Expose
  },

  props: [
    "items"
  ],

  created() {
    this.$store.dispatch("appData", {"title": this.$t("Immobilien")});
  }
};
</script>
